/* Meditonic | storewide header. Nav panel + cart count. */
(function () {
  var d = document;

  function boot(head) {
    if (head.mtBooted) return;
    head.mtBooted = true;

    var burger = head.querySelector('[data-mt-menu]');
    var panel = d.getElementById(head.dataset.mtPanel || 'mt-nav-panel');
    var cartBtn = head.querySelector('[data-mt-cart]');
    var countEl = head.querySelector('[data-mt-cart-count]');

    /* ---- scrolled state ---- */
    var ticking = false;
    var annBar = d.querySelector('.wt-announcement-bar');
    function paint() {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
      var annH = annBar ? annBar.offsetHeight : 0;
      head.style.setProperty('--mt-top', Math.max(0, annH - window.scrollY) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    paint();

    /* ---- nav panel ---- */
    if (burger && panel) {
      var items = panel.querySelectorAll('.mt-nav__link, .mt-nav__feature, .mt-nav__foot');
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--mt-d', (0.06 + i * 0.045).toFixed(3) + 's');
      }

      var open = function () {
        panel.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        d.body.classList.add('mt-nav-open');
        var sheet = panel.querySelector('.mt-nav__sheet');
        if (sheet) setTimeout(function () { sheet.focus(); }, 180);
      };
      var close = function (focusBack) {
        panel.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        d.body.classList.remove('mt-nav-open');
        if (focusBack) burger.focus();
      };

      burger.addEventListener('click', function () {
        if (panel.classList.contains('is-open')) close(false); else open();
      });
      var scrim = panel.querySelector('[data-mt-close]');
      if (scrim) scrim.addEventListener('click', function () { close(false); });
      d.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && panel.classList.contains('is-open')) close(true);
      });
      // keep focus inside the sheet while it is open
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      // a link click navigates, so let the panel shut behind it
      panel.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href]')) close(false);
      });
    }

    /* ---- cart count ---- */
    var last = null;
    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      if (last !== null && n !== last && cartBtn) {
        cartBtn.classList.remove('is-bumped');
        void cartBtn.offsetWidth;
        cartBtn.classList.add('is-bumped');
      }
      last = n;
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }
    refresh();
    d.addEventListener('cart-drawer:refresh', function () { setTimeout(refresh, 400); });
    d.addEventListener('sw:cart-added', function () { setTimeout(refresh, 300); });
    if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 200); }); } catch (e) {}
    }
  }

  function run() {
    d.querySelectorAll('[data-mt-head]').forEach(function (el) {
      try { boot(el); } catch (e) { if (window.console) console.warn('mt-header:', e); }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  d.addEventListener('shopify:section:load', run);
})();
